import { render, staticRenderFns } from "./lp-christmas-campaign-for-investors.vue?vue&type=template&id=5323555f&scoped=true"
import script from "./lp-christmas-campaign-for-investors.vue?vue&type=script&lang=js"
export * from "./lp-christmas-campaign-for-investors.vue?vue&type=script&lang=js"
import style0 from "./lp-christmas-campaign-for-investors.vue?vue&type=style&index=0&id=5323555f&prod&scoped=true&lang=css"
import style1 from "./lp-christmas-campaign-for-investors.vue?vue&type=style&index=1&id=5323555f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323555f",
  null
  
)

export default component.exports